import {createFileRoute} from '@tanstack/react-router';

import LegalHome from '@/public/views/LegalHome';

export const Route = createFileRoute('/(public)/legal')({
  component: LegalHome
});
